export default "<!-- <p>payment-result-normal works!</p> -->\r\n";